import _ChapterService from "../services/chapter-service";
import { IChapterService } from "../types/services/chapter-service";

const ChapterService: IChapterService = new _ChapterService();

export default ChapterService;
